export default {"src":"/_next/static/media/membership-1.2551034a.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};